<!-- eslint-disable max-len -->
<template>
  <svg
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    :width="width"
    viewBox="0 0 1240.1576 354.33071"
    version="1.1"
    xml:space="preserve"
    style="clip-rule: evenodd; fill-rule: evenodd; stroke-linejoin: round; stroke-miterlimit: 1.41420996"
    id="svg2"
    inkscape:version="0.91 r13725"
    sodipodi:docname="FARMDOK Logo Bild-Text- Farbe RGB - horizontal - small padding.svg"
  >
    <metadata id="metadata27">
      <rdf:RDF
        ><cc:Work rdf:about=""
          ><dc:format>image/svg+xml</dc:format
          ><dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" /><dc:title></dc:title></cc:Work
      ></rdf:RDF>
    </metadata>
    <defs id="defs25" />
    <sodipodi:namedview
      pagecolor="#ffffff"
      bordercolor="#666666"
      borderopacity="1"
      objecttolerance="10"
      gridtolerance="10"
      guidetolerance="10"
      inkscape:pageopacity="0"
      inkscape:pageshadow="2"
      inkscape:window-width="1600"
      inkscape:window-height="838"
      id="namedview23"
      showgrid="false"
      units="cm"
      borderlayer="true"
      inkscape:zoom="0.26499303"
      inkscape:cx="941.83692"
      inkscape:cy="-96.417728"
      inkscape:window-x="-8"
      inkscape:window-y="-8"
      inkscape:window-maximized="1"
      inkscape:current-layer="svg2"
    />
    <rect
      id="FARMDOK-Logo-Bild.2f.Text.--Farbe-RGB-.--horizontal"
      x="0.82999998"
      y="-162.6693"
      width="1431.39"
      height="516.66699"
      style="fill: none"
    />
    <g id="g4155" transform="translate(-96.228956,81.605923)">
      <g transform="translate(0,-162.66929)" id="Schriftzug-Braun">
        <g id="g6">
          <path
            inkscape:connector-curvature="0"
            id="path8"
            style="fill: #2a0900; fill-rule: nonzero"
            d="m 450.467,316.655 20.538,0 0,-47.566 58.942,0 0,-18.692 -58.942,0 0,-31.878 66.456,0 0,-18.692 -86.994,0 0,116.828 z"
          />
        </g>
        <path
          inkscape:connector-curvature="0"
          id="path10"
          style="fill: #2a0900; fill-rule: nonzero"
          d="m 528.166,316.655 21.039,0 12.022,-28.206 55.269,0 11.855,28.206 21.707,0 -51.428,-117.662 -19.035,0 -51.429,117.662 z m 40.575,-46.398 20.037,-46.731 20.204,46.731 -40.241,0 z"
        />
        <path
          inkscape:connector-curvature="0"
          id="path12"
          style="fill: #2a0900; fill-rule: nonzero"
          d="m 662.088,316.655 20.538,0 0,-40.723 25.715,0 28.719,40.723 24.212,0 -31.559,-44.228 c 16.364,-4.673 27.885,-16.189 27.885,-35.382 l 0,-0.334 c 0,-10.181 -3.506,-18.859 -9.684,-25.201 -7.514,-7.344 -19.036,-11.683 -33.729,-11.683 l -52.097,0 0,116.828 z m 20.538,-58.915 0,-39.221 29.889,0 c 15.195,0 24.211,6.843 24.211,19.36 l 0,0.334 c 0,11.85 -9.35,19.527 -24.044,19.527 l -30.056,0 z"
        />
        <path
          inkscape:connector-curvature="0"
          id="path14"
          style="fill: #2a0900; fill-rule: nonzero"
          d="m 776.008,316.655 20.204,0 0,-83.449 36.568,54.743 0.668,0 36.901,-55.076 0,83.782 20.538,0 0,-116.828 -21.874,0 -35.565,55.243 -35.566,-55.243 -21.874,0 0,116.828 z"
        />
        <path
          inkscape:connector-curvature="0"
          id="path16"
          style="fill: #2a0900; fill-rule: nonzero"
          d="m 911.197,316.655 43.581,0 c 36.734,0 62.115,-25.535 62.115,-58.414 l 0,-0.334 c 0,-32.879 -25.381,-58.08 -62.115,-58.08 l -43.581,0 0,116.828 z m 20.538,-18.693 0,-79.443 23.043,0 c 24.545,0 40.575,16.857 40.575,39.722 l 0,0.334 c 0,22.865 -16.03,39.387 -40.575,39.387 l -23.043,0 z"
        />
        <path
          inkscape:connector-curvature="0"
          id="path18"
          style="fill: #2a0900; fill-rule: nonzero"
          d="m 1090.42,318.24 c 35.899,0 61.279,-27.538 61.279,-60.416 l 0,-0.334 c 0,-32.879 -25.046,-60.083 -60.945,-60.083 -35.9,0 -61.28,27.538 -61.28,60.417 l 0,0.333 c 0,32.879 25.046,60.083 60.946,60.083 z m 0.334,-18.859 c -23.21,0 -39.741,-18.859 -39.741,-41.557 l 0,-0.334 c 0,-22.698 16.197,-41.224 39.407,-41.224 23.209,0 39.74,18.86 39.74,41.558 l 0,0.333 c 0,22.698 -16.197,41.224 -39.406,41.224 z"
        />
        <path
          inkscape:connector-curvature="0"
          id="path20"
          style="fill: #2a0900; fill-rule: nonzero"
          d="m 1164.13,316.655 20.538,0 0,-33.88 18.2,-18.693 39.907,52.573 24.879,0 -50.76,-66.592 48.59,-50.236 -25.214,0 -55.602,58.748 0,-58.748 -20.538,0 0,116.828 z"
        />
      </g>
      <path
        inkscape:connector-curvature="0"
        style="fill: #3cc961"
        d="m 167.579,177.11871 c -6.682,-5.512 -11.583,-12.102 -12.962,-21.411 -1.009,-6.807 0.116,-13.499 2.439,-19.846 4.138,-11.31 8.706,-22.46 13.207,-33.976 0.459,3.539 0.809,6.752 1.304,9.94 1.115,7.183 4.045,13.71 8.216,19.526 7.119,9.929 8.196,20.469 4.463,31.627 l 0,7.685 -2.858,0 13.364,0 c 2.383,-3.199 4.999,-6.216 7.997,-8.964 5.934,-5.432 13.17,-7.066 20.864,-7.257 10.686,-0.266 20.534,-3.084 29.413,-9.109 0.109,-0.074 0.974,-0.903 1.496,-0.989 -7.041,10.647 -14.365,21.99 -21.485,32.143 -4.52,6.443 -10.395,11.591 -18.043,14.223 -9.411,3.237 -18.495,1.366 -27.442,-1.995 -1.019,-0.382 -2.002,-0.864 -3.193,-1.385 l -16.78,0 0,-10.212 z M 296.746,3.9977055 l 54.167,0 0,183.3330045 -95.834,0 0,-16.667 79.167,0 0,-150.000004 -37.5,0 0,-16.6660005 z m -18.42,90.8400005 c -7.041,10.647004 -14.366,21.989004 -21.486,32.143004 -4.52,6.443 -10.395,11.591 -18.043,14.223 -9.41,3.237 -18.494,1.366 -27.442,-1.995 -1.024,-0.384 -2.012,-0.869 -3.212,-1.394 5.306,-9.349 10.542,-18.411 18.41,-25.622 5.933,-5.432 13.169,-7.066 20.864,-7.257 10.685,-0.266 20.533,-3.084 29.412,-9.109004 0.109,-0.074 0.974,-0.903 1.497,-0.989 z M 200.17,133.82871 c -10.972,-6.88 -19.817,-14.585 -21.75,-27.628 -1.008,-6.807004 0.117,-13.499004 2.439,-19.846004 4.138,-11.311 8.706,-22.46 13.207,-33.976 0.459,3.539 0.81,6.751 1.304,9.94 1.116,7.183 4.045,13.71 8.216,19.526 7.326,10.217 8.254,21.083004 4.125,32.603004 -2.282,6.373 -4.904,12.633 -7.541,19.381 z M 303.235,46.004706 c -6.84,10.342 -13.519,20.8 -20.61,30.966 -2.387,3.426 -5.592,6.414 -8.84,9.093 -8.836,7.283 -19.007,8.252 -29.731,5.385 -3.378,-0.899 -6.654,-2.193 -10.248,-3.393 5.814,-10.165 11.315,-20.013 20.351,-27.257 4.984,-3.993 10.845,-5.514 17.028,-5.678 11.456,-0.299 22.217,-2.72 32.05,-9.116 z m -77.261,37.807 c -6.101,-3.641 -11.091,-7.485 -15.129,-12.474 -8.255,-10.214 -8.516,-21.722 -4.61,-33.445 3.305,-9.928 7.522,-19.549 11.322,-29.3150005 0.721,-1.852 1.365,-3.736 2.435,-5.635 0.161,1.814 0.305,3.628 0.482,5.439 0.897,9.3550005 4.769,17.5360005 9.906,25.2290005 4.436,6.64 6.648,13.848 5.236,21.862 -0.556,3.143 -1.183,6.325 -2.254,9.318 -2.255,6.3 -4.826,12.48 -7.388,19.021 z m -25.061,-63.148 -16.667,0 0,33.334 -16.667,0 0,-50.0000005 33.334,0 0,16.6660005 z m 84.049,-45.833 c -0.516,14.891 0.417,29.2779995 -3.006,43.382 -2.921,12.04 -10.335,20.207 -21.677,24.845 -4.047,1.655 -8.273,2.871 -12.382,4.275 -8.311,-18.596 -7.551,-33.696 5.494,-46.39200046 7.549,-7.34800004 16.134,-13.63999954 24.277,-20.37599954 2.215,-1.835 4.52,-3.56 7.294,-5.734 z"
        id="Icon"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconTextLogoOriginal',
  props: {
    width: {
      type: [Number, String],
      default: 9448.82,
    },
    height: {
      type: [Number, String],
      default: 3410.59,
    },
  },
};
</script>

<style></style>
